// Slugs that have a matching `[data-provider="..."]` rule in
// ./provider-icon.css. Keep this set in sync with that file: any entry added
// or removed from the CSS should be reflected here, and vice versa.
const KNOWN_PROVIDER_ICON_SLUG_VALUES = [
  "access-people-hr",
  "adp",
  "apple",
  "asana",
  "auth0",
  "aws",
  "azure",
  "bamboo-hr",
  "bamboohr",
  "better-auth",
  "bitbucket",
  "box",
  "breathe-hr",
  "bubble",
  "cas",
  "cezanne-hr",
  "classlink",
  "clerk",
  "clever",
  "cloudflare",
  "confluence",
  "cyberark",
  "datadog",
  "descope",
  "discord",
  "dropbox",
  "duo",
  "firebase",
  "fourth",
  "frame-io",
  "front",
  "github",
  "gitlab",
  "gmail",
  "godaddy",
  "google",
  "google-analytics",
  "google-calendar",
  "google-cloud",
  "google-drive",
  "google-mail",
  "helpscout",
  "hibob",
  "hubspot",
  "intercom",
  "intuit",
  "jira",
  "jumpcloud",
  "keycloak",
  "lastpass",
  "linear",
  "linkedin",
  "login-gov",
  "microsoft",
  "microsoft-onedrive",
  "microsoft-onenote",
  "microsoft-outlook",
  "microsoft-outlook-calendar",
  "microsoft-sharepoint",
  "microsoft-teams",
  "microsoft-todo",
  "miniorange",
  "net-iq",
  "next-auth",
  "notion",
  "okta",
  "onelogin",
  "oracle",
  "personio",
  "ping-identity",
  "prefect",
  "pydantic-logfire",
  "react-native-expo",
  "rippling",
  "salesforce",
  "segment",
  "sentry",
  "shibboleth",
  "simple-saml-php",
  "slack",
  "snowflake",
  "splunk",
  "stripe",
  "stytch",
  "supabase",
  "test-idp",
  "vercel",
  "vmware",
  "workday",
  "workos",
  "xero",
  "zendesk",
] as const;

type KnownProviderIconSlug = (typeof KNOWN_PROVIDER_ICON_SLUG_VALUES)[number];

const KNOWN_PROVIDER_ICON_SLUGS: ReadonlySet<string> = new Set(
  KNOWN_PROVIDER_ICON_SLUG_VALUES,
);

const isKnownProviderIconSlug = (slug: string): slug is KnownProviderIconSlug =>
  KNOWN_PROVIDER_ICON_SLUGS.has(slug);

export {
  KNOWN_PROVIDER_ICON_SLUGS,
  KNOWN_PROVIDER_ICON_SLUG_VALUES,
  isKnownProviderIconSlug,
};
export type { KnownProviderIconSlug };
